import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Dialog, DialogContent } from '../components/ui/dialog';
import { X } from 'lucide-react';

const ArtPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const artworks = [
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/obu63l66_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM.jpeg',
      title: 'Cosmic Dreams',
    },
    {
      id: 2,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/yu974o7p_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%281%29.jpeg',
      title: 'Ethereal Journey',
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/9ak2x0pb_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%282%29.jpeg',
      title: 'Delicate Forms',
    },
    {
      id: 4,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/aoyou4f4_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%283%29.jpeg',
      title: 'Inner Voyage',
    },
    {
      id: 5,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/nsi2ouyb_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%284%29.jpeg',
      title: 'Misty Solitude',
    },
    {
      id: 6,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/hnmtif43_Surreal%20peace%20.png',
      title: 'Twilight Reverie',
    },
    {
      id: 7,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/v5cca37o_Coldly%20.png',
      title: 'Electric Dreams',
    },
    {
      id: 8,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/4nexr8pz_Qaeda.png',
      title: 'Silent Ascent',
    },
    {
      id: 9,
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/bjm9uwvk_The%20view.png',
      title: 'Emerald Portal',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 px-6">
          <div className="max-w-7xl mx-auto">
            {/* Section Header */}
            <div className="mb-16">
              <h1
                className="text-5xl md:text-6xl font-bold mb-4"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Digital Art
              </h1>
              <p className="text-gray-600 text-lg">
                Exploring visual narratives through digital illustration
              </p>
            </div>

            {/* Gallery Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {artworks.map((artwork) => (
                <div
                  key={artwork.id}
                  className="group cursor-pointer overflow-hidden rounded-lg bg-gray-100 aspect-square relative"
                  onClick={() => setSelectedImage(artwork)}
                >
                  <img
                    src={artwork.url}
                    alt={artwork.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-300 flex items-center justify-center">
                    <p className="text-white text-xl font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {artwork.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* Lightbox Dialog */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-[100vw] max-h-[100vh] w-screen h-screen p-0 bg-black/95 border-none">
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 z-50 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
          >
            <X className="text-white" size={24} />
          </button>
          {selectedImage && (
            <div className="flex items-center justify-center w-full h-full p-4 md:p-8">
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-full w-auto h-auto object-contain"
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ArtPage;
